import React from 'react';
import { Box, Button, Tooltip } from '@mui/material';

const QUICK_ACTIONS = [
    {
        id: 'open-invoices',
        label: 'Offene Rechnungen',
        intent: 'list_open_invoices',
        slots: {},
        message: 'Kannst du mir die offenen Rechnungen zeigen?'
    },
    {
        id: 'bwa',
        label: 'BWA Report',
        intent: 'request_report',
        slots: { report_type: 'BWA' },
        message: 'Bitte erstelle den aktuellen BWA-Report.'
    },
    {
        id: 'cashflow-baseline',
        label: 'Cashflow (Basis)',
        intent: 'request_report',
        slots: { report_type: 'cashflow', scenario: 'baseline' },
        message: 'Wie sieht die Cashflow-Prognose im Basisszenario aus?'
    },
    {
        id: 'help',
        label: 'Hilfe: Umsatzsteuer',
        intent: 'help_topic',
        slots: { topic: 'Umsatzsteuer' },
        message: 'Ich brauche Hilfe zum Thema Umsatzsteuer.'
    }
];

export default function QuickActions({ onAction, disabled }) {
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, px: 2, pb: 1 }}>
            {QUICK_ACTIONS.map((action) => (
                <Tooltip title={action.message} key={action.id} placement="top">
                    <span>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={disabled}
                            onClick={() => onAction?.(action)}
                        >
                            {action.label}
                        </Button>
                    </span>
                </Tooltip>
            ))}
        </Box>
    );
}
